import { setLanguage } from "config/language";
import Banner from "../common/Banner";
import { useEffect, useState } from "react";
import BazAIHelmet from "../common/BazAIHelmet";
import { baseUrl } from "config/apiUrl";
import { hotelPageData, hotelFAQs } from "./hotelFacilities";
import UpdateNavbar from "pages/UpdatedLanding/Common/UpdateNavbar";
import UpdateFooter from "pages/UpdatedLanding/Common/UpdateFooter";
import EnhancedPageLayout from "pages/UpdatedLanding/Common/EnhancedPageLayout";

export default function LandingForHotel() {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    function onScroll() {
      setScrollTop(document.documentElement.scrollTop);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);
  if (localStorage.getItem("lan") === null) {
    setLanguage();
  }

  return (
    <>
      <BazAIHelmet
        title="AI-Powered Procurement for Hotels and Hospitality"
        description="EkkBaz AI helps hotels reduce procurement costs by 30%, automate supplier management, and eliminate manual purchasing processes. Purpose-built for hospitality procurement teams."
        keywords="hotel procurement software, hospitality procurement AI, hotel supplier management, food and beverage procurement, hotel purchasing system, hospitality supply chain automation"
        image="/assets/images/LogoAI.png"
        url={`${baseUrl.webUrl}/industry/hotel`}
        industryName="Hotel"
        faqItems={hotelFAQs}
      />
      <UpdateNavbar />
      <Banner
        headline="Hotel & Hospitality"
        subtitle="Reduce procurement costs by 30%, automate supplier management, and give your team back 2+ hours every day — purpose-built for hospitality."
        from="hotel"
      />
      <EnhancedPageLayout {...hotelPageData} />
      <UpdateFooter />
    </>
  );
}
